import { Control, Controller } from 'react-hook-form';
import {
  FormControl,
  FormLabel,
  NumberDecrementStepper,
  NumberIncrementStepper,
  NumberInput,
  NumberInputField,
  NumberInputProps,
  NumberInputStepper,
} from '@cdl/heartbeat-react';
import { FormValues } from '../../../types/annotation-task-detail.type';

type Props = {
  type: string;
  control: Control<FormValues>;
} & NumberInputProps;

export const NumberForm: React.FC<Props> = ({
  type,
  control,
  isRequired,
  ...rest
}) => {
  return (
    <FormControl pb='m'>
      <FormLabel htmlFor={type}>
        {type.charAt(0).toUpperCase() + type.slice(1)}
        {isRequired && '*'}
      </FormLabel>
      <Controller
        name={type}
        control={control}
        rules={{
          required: isRequired ? 'Field is required' : false,
        }}
        render={({ field: { ref, ...restField } }) => (
          <NumberInput
            min={0}
            {...restField}
            {...rest}
            onChange={(value) =>
              restField.onChange(value ? parseFloat(value) : '')
            }
          >
            <NumberInputField ref={ref} name={restField.name} />
            <NumberInputStepper>
              <NumberIncrementStepper />
              <NumberDecrementStepper />
            </NumberInputStepper>
          </NumberInput>
        )}
      />
    </FormControl>
  );
};
